// ========================================
// Category Dashboards — Panel Alumnado y CRM, diseño A (2026-10-25)
// El embudo del primer contacto a la matrícula arriba, después a quién contactar, las
// entrevistas, las cifras de alumnado, los contactos por mes, el interés por formación, las
// tutorías y las herramientas. Bloques personalizables como el Inicio (DashboardView); estilos
// en inicio.css (.inv-*) y crm.css (.crm-*).
// ========================================

Object.assign(window.CategoryDashboards, {
    // Lo que llega aparte (pre-matrículas, solicitudes, tutorías): se guarda para repintar sin «…».
    _crmData: {},

    renderAlumnadoCRM() {
        const D = DashboardView;
        const students = typeof DataManager !== 'undefined' ? DataManager.getAll(DataManager.KEYS.STUDENTS) : [];
        // Contact figures come summarised from the server (/api/leads/summary), not as the whole list.
        const summary = (typeof FileStorage !== 'undefined' && FileStorage.dataStore.leadsSummary) || { total: 0, byStatus: {}, topInterests: [], interestTotal: 0, pending: [], monthly: [] };
        const isEditMode = this.isEditMode('alumnocrm');
        const widgetsConfig = this.getWidgetsConfig('alumnocrm');
        const ctx = {
            summary,
            activeCount: students.filter(s => s.active !== false).length,
            inactiveCount: students.filter(s => s.active === false).length
        };
        this._lastCrmCtx = ctx;
        const now = new Date(), course = D._courseLabel(now).replace('/', ' / ');

        return `
        <div class="dnr-proposal inicio-view crm-view">
            <section class="inv-head">
                <div class="inv-head-text">
                    <h1 class="inv-title">Alumnado y CRM</h1>
                    <p class="inv-sub">Curso ${course} · ${ctx.activeCount} alumnos activos · ${summary.total} contactos</p>
                </div>
                <button type="button" id="btn-cog-alumnocrm" class="inv-btn" style="display: ${isEditMode ? 'none' : 'flex'};" ${UIEvents.attr('click', () => CategoryDashboards.toggleWidgetDrawer('alumnocrm'))}>
                    <i class="fas fa-sliders" aria-hidden="true"></i> Personalizar
                </button>
            </section>
            ${D._renderDrawer(widgetsConfig, isEditMode, 'alumnocrm', 'Personalizar el panel')}
            ${D._renderEditBanner(isEditMode, 'alumnocrm', 'el panel')}
            <div id="widgets-grid-alumnocrm" class="dnr-widget-grid inv-grid">
                ${widgetsConfig.map((w, i) => this.renderCrmWidget(w, isEditMode, ctx, i)).join('')}
            </div>
        </div>`;
    },

    renderCrmWidget(w, isEditMode, ctx, i) {
        const builders = {
            'crm-embudo': () => this._crmEmbudo(ctx),
            'crm-por-contactar': () => this._crmPorContactar(ctx),
            'crm-entrevistas': () => this._crmEntrevistas(),
            'crm-cifras': () => this._crmCifras(ctx),
            'crm-meses': () => this._crmMeses(ctx),
            'crm-interes': () => this._crmInteres(ctx),
            'crm-tutorias': () => this._crmTutorias(),
            'crm-herramientas': () => this._crmHerramientas()
        };
        if (!builders[w.id]) return '';
        return DashboardView._dnrWidgetShell(w, isEditMode, builders[w.id](), i, 'alumnocrm');
    },

    _crmRepaint(id) {
        const card = document.getElementById('widget-' + id);
        const config = this.getWidgetsConfig('alumnocrm'), w = config.find(x => x.id === id);
        if (!card || !w || !this._lastCrmCtx) return;
        SafeHTML.replace(card, this.renderCrmWidget(w, this.isEditMode('alumnocrm'), this._lastCrmCtx, config.indexOf(w)));
    },

    _crmCount(n) {
        return n === undefined ? '…' : n;
    },

    _crmEmbudo(ctx) {
        const D = DashboardView, s = ctx.summary, by = s.byStatus || {}, pre = this._crmData.pre;
        const pct = n => (typeof n === 'number' && s.total ? `${Math.round(n / s.total * 100)} %` : '');
        const steps = [
            { n: by.pending || 0, label: 'Por contactar', tone: 'is-warn', go: 'leads' },
            { n: by.contacted || 0, label: 'Contactados', tone: '', go: 'leads' },
            { n: by.visit || 0, label: 'Con visita', tone: 'is-blue', go: 'leads' },
            { n: pre ? pre.requested : pre === null ? '—' : undefined, label: 'Entrevista pedida', tone: 'is-violet', go: 'entrevistas' },
            { n: pre ? pre.count : pre === null ? '—' : undefined, label: 'Pre-matriculados', tone: 'is-ok', go: 'pre-matricula' },
            { n: by.enrolled || 0, label: 'Matriculados', tone: 'is-strong', go: 'alumnado' }
        ];
        return `
            ${D._head(`Del primer contacto a la matrícula <span class="inv-muted">· % sobre los ${s.total} contactos</span>`, { label: 'Contactos', go: () => App.navigate('leads') })}
            <div class="crm-steps">
                ${steps.map((st, i) => `
                    <button type="button" class="crm-step ${st.tone}" ${UIEvents.attr('click', () => App.navigate(st.go))}>
                        <span class="crm-step-n">Paso ${i + 1}</span>
                        <span class="crm-step-value"><span class="crm-step-count">${this._crmCount(st.n)}</span><span class="crm-step-pct">${pct(st.n)}</span></span>
                        <span class="crm-step-label">${st.label}</span>
                    </button>`).join('')}
            </div>`;
    },

    _crmPorContactar(ctx) {
        const D = DashboardView, s = ctx.summary, waiting = (s.byStatus || {}).pending || 0;
        const list = (s.pending || []).slice(0, 5);
        return `
            <div class="inv-card-head">
                <h2 class="inv-card-title">Por contactar ${waiting ? `<span class="inv-badge is-warn">${waiting}</span>` : ''}</h2>
                <button type="button" class="inv-link" ${UIEvents.attr('click', () => App.navigate('leads'))}>Ver todos <span aria-hidden="true">→</span></button>
            </div>
            <div class="inv-list">
                ${list.length ? list.map(l => {
                    const age = AccionesPendientesView._age(l.createdAt);
                    return `
                        <div class="crm-lead">
                            <span class="inv-avatar is-blue" aria-hidden="true">${Utils.sanitizeHTML(D._initials(l.nombre))}</span>
                            <span class="inv-person-text"><strong>${Utils.sanitizeHTML(l.nombre || l.email || 'Contacto')}</strong><span>${Utils.sanitizeHTML([l.interes || 'Sin interés indicado', l.origen].filter(Boolean).join(' · '))}</span></span>
                            <span class="ap-age ${age.days >= 7 ? 'is-old' : ''}">${age.text}</span>
                            <button type="button" class="ap-btn is-primary is-small" ${UIEvents.attr('click', () => App.navigate('leads'))}>Contestar</button>
                        </div>`;
                }).join('') : '<p class="inv-empty">Todos los contactos tienen respuesta.</p>'}
            </div>`;
    },

    _crmEntrevistas() {
        const D = DashboardView, pre = this._crmData.pre, today = D._iso(new Date());
        let body = '<p class="inv-empty">Cargando…</p>';
        if (pre === null) body = '<p class="inv-empty">No se pudieron cargar las entrevistas.</p>';
        else if (pre) {
            const list = pre.interviews.slice(0, 5);
            body = list.length ? list.map(s => {
                const dated = s.interviewDate && s.interviewTime, d = dated ? new Date(`${s.interviewDate}T12:00:00`) : null;
                const top = !dated ? 'SIN' : s.interviewDate === today ? 'HOY' : d.toLocaleDateString('es-ES', { weekday: 'short' }).replace('.', '').toUpperCase() + ' ' + d.getDate();
                return `
                    <button type="button" class="crm-interview" ${UIEvents.attr('click', () => App.navigate('entrevistas'))}>
                        <span class="crm-date ${!dated ? 'is-undated' : s.interviewDate === today ? 'is-today' : ''}"><span>${top}</span><strong>${dated ? Utils.sanitizeHTML(s.interviewTime) : 'FECHA'}</strong></span>
                        <span class="inv-person-text"><strong>${Utils.sanitizeHTML(`${s.firstName || ''} ${s.lastName1 || ''}`.trim() || 'Solicitante')}</strong><span>${Utils.sanitizeHTML(s.courseName || 'Sin formación')}</span></span>
                    </button>`;
            }).join('') : '<p class="inv-empty">No hay entrevistas pedidas.</p>';
        }
        return `${D._head('Próximas entrevistas', { label: 'Entrevistas', go: () => App.navigate('entrevistas') })}<div class="inv-list">${body}</div>`;
    },

    _crmCifras(ctx) {
        const D = DashboardView, s = ctx.summary, pre = this._crmData.pre, req = this._crmData.requests;
        const enrolled = (s.byStatus || {}).enrolled || 0;
        const cells = [
            { section: 'alumnado', label: 'Alumnos activos', value: ctx.activeCount, sub: 'Con su ficha activa', go: 'alumnado' },
            { section: 'pre-matricula', label: 'Pre-matriculados', value: pre ? pre.count : pre === null ? '—' : '…', sub: 'Solicitudes de pre-matrícula', go: 'pre-matricula', tone: 'is-ok' },
            { section: 'alumnado', label: 'Bajas y pausas', value: ctx.inactiveCount, sub: 'Fichas inactivas', go: 'alumnado', tone: ctx.inactiveCount ? 'is-warn' : '' },
            req !== undefined || this._crmCanRequests() ? { section: 'alumnado', label: 'Solicitudes', value: req === undefined ? '…' : req === null ? '—' : req, sub: 'Por revisar en Admisiones', go: 'alumnado/admissions', tone: req ? 'is-warn' : '' } : null,
            { section: 'leads', label: 'Conversión', value: s.total ? `${Math.round(enrolled / s.total * 100)} %` : '—', sub: 'De contacto a matrícula', go: 'leads' }
        ].filter(c => c && D._can(c.section));
        return `
            <div class="inv-money">
                ${cells.map(c => `
                    <button type="button" class="inv-money-cell" ${UIEvents.attr('click', () => App.navigate(c.go))}>
                        <span class="inv-label">${c.label}</span>
                        <span class="inv-money-value ${c.tone || ''}">${Utils.sanitizeHTML(String(c.value))}</span>
                        <span class="inv-money-sub">${c.sub}</span>
                    </button>`).join('')}
            </div>`;
    },

    _crmCanRequests() {
        return ['admin', 'coordinator', 'rrhh'].includes(AuthManager.currentUser?.role);
    },

    _crmMeses(ctx) {
        const D = DashboardView, months = (ctx.summary.monthly || []).map(m => ({
            name: new Date(m.year, m.month, 1).toLocaleDateString('es-ES', { month: 'short' }).replace('.', '').toUpperCase(), n: m.count }));
        const max = Math.max(1, ...months.map(m => m.n)), total = months.reduce((sum, m) => sum + m.n, 0);
        return `
            ${D._head(`Contactos por mes <span class="inv-muted">${total} en ${months.length} meses</span>`, null)}
            <div class="aca-bars crm-months" style="grid-template-columns: repeat(${Math.max(1, months.length)}, minmax(0, 1fr));">
                ${months.map(m => `
                    <div class="aca-bar">
                        <strong class="crm-month-n">${m.n}</strong>
                        <span class="aca-bar-track" aria-hidden="true"><i class="is-teal" style="height:${m.n ? Math.max(3, Math.round(m.n / max * 100)) : 0}%"></i></span>
                        <span class="inv-label">${m.name}</span>
                    </div>`).join('')}
            </div>`;
    },

    _crmInteres(ctx) {
        const D = DashboardView, s = ctx.summary;
        const top = (s.topInterests || []).slice(0, 5), total = s.interestTotal || 0;
        const rest = Math.max(0, total - top.reduce((sum, [, n]) => sum + n, 0));
        const rows = [...top, ...(rest ? [['Otros', rest]] : [])].map(([name, n]) => ({ name, pct: total ? Math.round(n / total * 100) : 0 }));
        const max = Math.max(1, ...rows.map(r => r.pct));
        return `
            ${D._head('Interés por formación', D._can('pre-matricula') ? { label: 'Pre-Matrícula', go: () => App.navigate('pre-matricula') } : null)}
            ${rows.length ? `<div class="inv-funnel crm-interest">
                ${rows.map(r => `
                    <span class="inv-funnel-l" title="${Utils.sanitizeHTML(r.name)}">${Utils.sanitizeHTML(r.name)}</span>
                    <span class="inv-bar" aria-hidden="true"><i style="width:${Math.round(r.pct / max * 100)}%"></i></span>
                    <strong class="inv-funnel-n">${r.pct} %</strong>`).join('')}
            </div>` : '<p class="inv-empty">Los contactos aún no han indicado interés.</p>'}
            <p class="inv-empty">Según lo que piden los contactos al escribir</p>`;
    },

    _crmTutorias() {
        const D = DashboardView, t = this._crmData.tutorias;
        let body = '<p class="inv-empty">Cargando…</p>';
        if (t === null) body = '<p class="inv-empty">No se pudieron cargar las tutorías.</p>';
        else if (t) {
            const day = (date, time) => `${new Date(`${date}T12:00:00`).toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric' })}${time ? `, ${time}` : ''}`;
            body = `
                <div class="inv-stats crm-two">
                    ${D._stat(t.week, 'Esta semana', 'is-ok')}
                    ${D._stat(t.unconfirmed.length, 'Por confirmar', t.unconfirmed.length ? 'is-warn' : '')}
                </div>
                ${[...t.upcoming.map(x => ({ who: [x.studentName, x.professorName].filter(Boolean).join(' · '), when: day(x.confirmedDate, x.confirmedTime) })),
                   ...t.unconfirmed.map(x => ({ who: [x.studentName, x.professorName].filter(Boolean).join(' · '), when: 'por confirmar' }))].slice(0, 4).map(r => `
                    <button type="button" class="inv-line" ${UIEvents.attr('click', () => App.navigate('tutorias-admin'))}>
                        <span>${Utils.sanitizeHTML(r.who || 'Tutoría')}</span><span class="inv-muted">${Utils.sanitizeHTML(r.when)}</span>
                    </button>`).join('')}`;
        }
        return `${D._head('Tutorías', { label: 'Tutorías', go: () => App.navigate('tutorias-admin') })}${body}`;
    },

    _crmHerramientas() {
        const tools = [['Alumnado', 'alumnado', 'alumnado'], ['Contactos', 'leads', 'leads'], ['Pre-Matrícula', 'pre-matricula', 'pre-matricula'],
            ['Entrevistas', 'entrevistas', 'entrevistas'], ['Tutorías', 'tutorias-admin', 'tutorias-admin'], ['Plantillas de correo', 'email-templates', 'email-templates']]
            .filter(t => DashboardView._can(t[2]));
        return `
            <nav class="aca-tools" aria-label="Herramientas de alumnado">
                ${tools.map(([label, route]) => `<a href="/${route}" class="inv-quick-link" ${UIEvents.attr('click', event => { event.preventDefault(); App.navigate(route); })}>${label}</a>`).join('')}
                <a href="/inscribete" target="_blank" rel="noopener" class="inv-quick-link">Inscríbete <span class="inv-muted" aria-hidden="true">↗</span><span class="ap-sr">(se abre en otra pestaña)</span></a>
            </nav>`;
    },

    // Pre-matrículas (entrevistas pedidas y cuántas hay), solicitudes por revisar y tutorías.
    async initAlumnadoCRM() {
        const D = DashboardView, headers = { 'X-SICAF-CSRF': AuthManager.getCsrfToken() }, epoch = AuthManager._epoch;
        const load = async url => { const res = await fetch(url, { headers }); const data = await res.json(); if (!res.ok || !data.success) throw new Error(url); return data; };
        const jobs = [];
        if (D._can('pre-matricula') || D._can('entrevistas')) jobs.push(load('/api/pre-registration').then(data => {
            // Misma fuente y filtro que Planificación de Entrevistas y Pre-Matrícula.
            const real = (data.preRegistrations || []).filter(s => !s.isProvisional && !(s.firstName === 'PLAZA' && s.lastName1 === 'PENDIENTE'));
            const requested = real.filter(s => s.status === 'entrevista_solicitada');
            const dated = requested.filter(s => s.interviewDate && s.interviewTime).sort((a, b) => `${a.interviewDate}T${a.interviewTime}`.localeCompare(`${b.interviewDate}T${b.interviewTime}`));
            const today = D._iso(new Date());
            this._crmData.pre = { count: real.length, requested: requested.length, interviews: [...dated.filter(s => s.interviewDate >= today), ...requested.filter(s => !(s.interviewDate && s.interviewTime))] };
        }).catch(() => { this._crmData.pre = null; }));
        if (this._crmCanRequests()) jobs.push(load('/api/enrollments').then(data => {
            this._crmData.requests = (data.enrollments || []).filter(e => e.status === 'pending' || e.status === 'interview').length;
        }).catch(() => { this._crmData.requests = null; }));
        if (D._can('tutorias-admin')) jobs.push(load('/api/tutorias/stats').then(data => {
            const all = data.stats.tutorias || [], monday = D._monday(), today = D._iso(new Date());
            const from = D._iso(monday), to = D._iso(new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6));
            const confirmed = all.filter(t => t.status === 'confirmed' && t.confirmedDate);
            this._crmData.tutorias = {
                week: confirmed.filter(t => t.confirmedDate >= from && t.confirmedDate <= to).length,
                upcoming: confirmed.filter(t => t.confirmedDate >= today).sort((a, b) => `${a.confirmedDate} ${a.confirmedTime || ''}`.localeCompare(`${b.confirmedDate} ${b.confirmedTime || ''}`)),
                unconfirmed: all.filter(t => ['pending', 'proposed_1', 'proposed_3'].includes(t.status))
            };
        }).catch(() => { this._crmData.tutorias = null; }));
        await Promise.all(jobs);
        if (epoch !== AuthManager._epoch || App.currentView !== 'alumnocrm') return;
        ['crm-embudo', 'crm-entrevistas', 'crm-cifras', 'crm-tutorias'].forEach(id => this._crmRepaint(id));
    }
});
